import React from 'react'
import ReactDOM from 'react-dom'
import WebFont from 'webfontloader'
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'animate.css/animate.min.css'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import App from '../src/App/index'
import * as serviceWorker from './serviceWorker'
import { JazeelProvider } from './Influencers/utils/JazeelContext'
import { BrandProvider } from './Brands/utils/BrandContext'

WebFont.load({
  google: {
    families: ['Montserrat', 'Tajawal'],
  },
})
ReactDOM.render(
  <JazeelProvider>
    <BrandProvider>
      <App />
    </BrandProvider>
  </JazeelProvider>,
  document.getElementById('root'),
)

serviceWorker.unregister()
